import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import InstructionHint from '@/components/ui/InstructionHint';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const UNREPAIRABLE_DAMAGES_BEFORE_ACCIDENT = {
  YES: 'yes',
  NO: 'no',
} as const;

export const UNREPAIRABLE_DAMAGES_BEFORE_ACCIDENT_NAME =
  'unrepairable_damages_before_accident';
export const UNREPAIRABLE_DAMAGES_BEFORE_ACCIDENT_NAME_COMPLEMENTARY =
  'unrepairable_damages_before_accident_complementary';

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const RadioGroupNoRepairableDamage: FC<Props> = ({
  name,
  isComplementary = false,
}) => {
  const fieldName =
    name ??
    (isComplementary
      ? UNREPAIRABLE_DAMAGES_BEFORE_ACCIDENT_NAME_COMPLEMENTARY
      : UNREPAIRABLE_DAMAGES_BEFORE_ACCIDENT_NAME);

  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={fieldName}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            <span
              dangerouslySetInnerHTML={{
                __html: i18n.t(
                  'Czy samochód miał przed zdarzeniem szkody, które <span class="underline underline-offset-4 decoration-1">nie zostały</span> naprawione?'
                ),
              }}
            />
          </FormLabel>
          <InstructionHint
            title={
              <span
                dangerouslySetInnerHTML={{
                  __html: i18n.t(
                    'Wybierz odpowiedź <b>Tak</b>, jeśli samochód był uszkodzony przed zgłaszaną szkodą, a następnie wypisz wszystkie uszkodzenia na stan Twojej wiedzy.'
                  ),
                }}
              />
            }
          />
          <FormControl>
            <RadioGroup
              {...field}
              layout={'horizontal'}
              data-testid="radio-group-no-repairable-damage"
            >
              <RadioItem
                value={UNREPAIRABLE_DAMAGES_BEFORE_ACCIDENT.YES}
                label={i18n.t('Tak')}
                data-testid="radio-item-no-repairable-damage-yes"
              />
              <RadioItem
                value={UNREPAIRABLE_DAMAGES_BEFORE_ACCIDENT.NO}
                label={i18n.t('Nie')}
                data-testid="radio-item-no-repairable-damage-no"
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
